import React, { useMemo } from 'react';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';
// @ts-ignore
import '@react-pdf-viewer/core/lib/styles/index.css';
import './doc-view-card.scss';
import { InvoiceDocs } from '@zonofi/zono-money-store';

interface DocViewCardProps {
  docs: InvoiceDocs;
}

export const DocViewCard: React.FC<DocViewCardProps> = ({ docs }) => {
  const isImage = useMemo(() => docs?.mimetype.startsWith('image/'), [docs]);
  const isPdf = useMemo(() => docs?.mimetype === 'application/pdf', [docs]);

  if (!docs) return null;

  return (
    <div className="doc-view-content">
      {isImage && <img src={docs.url} className="doc-view-image" />}
      {isPdf && (
        <div className="doc-view-pdf">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
            <Viewer
              fileUrl={docs.url}
              defaultScale={SpecialZoomLevel.PageWidth}
            />
          </Worker>
        </div>
      )}
    </div>
  );
};
